import { ActionButton } from "@via/components/action-button/action-button.tsx";
import { GenericError } from "@via/components/error.tsx";
import { ROUTES } from "@via/utils/constants.tsx";
import { type JSX } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useGlobal } from "@via/hooks/useGlobal.tsx";
import MissingDatasetIdError from "@via/pages/data/data-connections/missing-dataset-id-error.tsx";

export default function NoActiveConnection({
  genericErrorMessage = "There is no active connection.",
}: {
  genericErrorMessage?: string;
}): JSX.Element {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setSelectedCollectionId } = useGlobal();

  const datasetId = searchParams.get("datasetId");

  // If datasetId is missing, show error page instead of navigating to deprecated route
  if (!datasetId) {
    return <MissingDatasetIdError />;
  }

  const handleCreateConnectionNavigation = () => {
    setSelectedCollectionId(null);
    navigate(`${ROUTES.CREATE_DATA_SOURCE}?datasetId=${datasetId}`);
  };

  return (
    <div className="via-generic-error gap-4">
      <GenericError message={genericErrorMessage} />
      <ActionButton
        button="Create New Connection"
        primary={true}
        onClick={handleCreateConnectionNavigation}
      />
    </div>
  );
}
